import {
  _t
} from "./chunk.PSO6NFST.js";

// src/runtime/styling/internal.ts
import {
  createContext
} from "react";
var TwindContext = createContext(_t);

export {
  TwindContext
};
